import React, {PropTypes} from 'react';
import ClubMemberRow from './ClubMemberRow';
import Loading from '../Loading';

const ClubMemberList = ({members, loading, deleteMember, restoreMember}) => {
  return (
    <div>
      <table className="table table-responsive  table-bordered table-background">
        <thead>
          <tr>
            {/*<th>
              <span className="hidden-xs">Aktiv</span>
            </th>*/}
            <th>Fornavn</th>
            <th>Etternavn</th>
            <th className="hidden-xs">Tlf</th>
            <th className="hidden-xs">Epost</th>
            <th className="hidden-xs hidden-sm">Adresse</th>
            <th className="hidden-xs hidden-sm"/>
          </tr>
        </thead>
        <tbody>
          {members.map((member, index) => {
            return (<ClubMemberRow
              key={index}
              deleteMember={deleteMember}
              restoreMember={restoreMember}
              member={member} />);
          })}
        </tbody>
      </table>
      <Loading loading={loading} />
    </div>
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
ClubMemberList.propTypes = {
  members: PropTypes.array.isRequired,
  deleteMember: PropTypes.func.isRequired,
  restoreMember: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

export default ClubMemberList;



/** WEBPACK FOOTER **
 ** ./src/components/club/ClubMemberList.js
 **/